import React, { useState } from "react";
import { Button } from "../../../ui/button";
import UpdatesList from "./updates-list";

const UpdatesContent = () => {
  const [activeFilter, setActiveFilter] = useState("All")

  const filterTypes = ["All", "New", "Improved", "Fixed", "Announcement"]

  return (
    <div className="flex-1 bg-gray-50">
      {/* Hero section with updated light purple gradient background */}
      <div className="bg-gradient-to-b from-[#FDF8FF] to-[#EEDDF8]">
        <div className="container mx-auto px-4 py-16">
          <div className="max-w-4xl mx-auto">
            <div
              className="text-center mb-12 animate-fade-up opacity-0"
              style={{ animationDelay: "0.3s", animationFillMode: "forwards" }}
            >
              <h1 className="text-4xl font-bold text-gray-900">
                Product Updates
              </h1>
              <p className="text-xl text-gray-600 mt-3">
                Stay up to date with the latest improvements and announcements
              </p>
            </div>

            <div
              className="flex flex-wrap gap-2 justify-center mb-10 animate-fade-up opacity-0"
              style={{ animationDelay: "0.6s", animationFillMode: "forwards" }}
            >
              {filterTypes.map((type, index) => (
                <Button
                  key={type}
                  variant={activeFilter === type ? "default" : "outline"}
                  className={`rounded-full px-6 transition-all duration-300 ${
                    activeFilter === type
                      ? "bg-[#9b87f5] hover:bg-[#7E69AB]"
                      : "hover:scale-105"
                  }`}
                  onClick={() => setActiveFilter(type)}
                  style={{ animationDelay: `${0.7 + index * 0.1}s` }}
                >
                  {type}
                </Button>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Updates content section */}
      <div className="container mx-auto px-4 py-12">
        <div className="max-w-4xl mx-auto">
          <UpdatesList activeFilter={activeFilter} />
        </div>
      </div>
    </div>
  )
}

export default UpdatesContent
